<app-table
  [columns]="getColumns()"
  [values]="promotions"
  (filtersChanged)="onTableFiltersChanged($event)"
></app-table>
